<template>

  <el-container class="bizFlow-page">
    <el-main class="bizFlow-page">
      <bizflow-left v-show = 'isShowFlowLeft' :stepIndex="getleftStepIndex()" :leftStepArr="leftStepArr" @tack-click="tackClick" @leftItemClick="leftItemClick" :showButton="showButton" :leftButtonText="leftButtonText" @jump-click="jumpClick" :showJumpButton="showJumpButton"></bizflow-left>
      <div :class="[secondTopStepArr.length>1?'hasSecondTitle': groupConfig && groupConfig.length && !isBizPage?'top':'','routeBox']">
        <bizflow-top :bizTopIndex="stepIndex" :secondTopStepArr="secondTopStepArr" @topItemClick="topItemClick" v-if="secondTopStepArr.length>1"></bizflow-top>
        <keep-alive>
          <router-view class="router-view"
            ref="routerView"
            :groupConfig="groupConfig"
            :groupDatas.sync="groupDatas"
            :groupDatasTpl="groupDatasTpl"
            :oldGroupDatas.sync="oldGroupDatas"
            :bizData.sync="bizData"
            :historyData="historyData"
            :oppBusiData.sync="oppBusiData"
            :isShowPrev="isShowPrev"
            :isShowNext="isShowNext"
            :isShowPageIndex="isShowPageIndex"
            :busiCode="busiCode"
            :openAcctType="openAcctType"
            :bizConfig="bizConfig"
            :save="save"
            :clickLeftStep = "isClickLeftStep"
            :disabledArray="disabledArray"
            :noUpdateApptStatus="noUpdateApptStatus"
            @clickLeftStepBack="clickLeftStepBack"
            @on-next-click="nextStep"
            @on-prev-click="prevStep"
            @change-toplink-name="changeToplinkName"
            @travel-change="travelChange"
            @updateLeftStatusByRouter="updateLeftStatusByRouter"
          >
            </router-view>
        </keep-alive>
      </div>
    </el-main>
    <try-again :message-type="messageType" :messageText="messageText" v-on:reloadPage="refreshPage" v-if="messageTypeShow"></try-again>
    <!-- <reject-remark-tip></reject-remark-tip> -->
    <!-- <message-box :messageBoxProps='messageBoxProps'></message-box> -->
    <!-- <loading-page  :showLoadingPage='showLoadingPage' :loadingContents='loadingContents' :loadingInterTimeStep='loadingInterTimeStep' :loadingTextRepeatBool='loadingTextRepeatBool'></loading-page> -->
  </el-container>
</template>

<script>
import TryAgain from "@/components/common/tryAgain.vue";
// import messageBox from "../../components/common/messageBox";
// import rejectRemarkTip from "../../components/common/rejectRemarkTip";
import oppService from "@/service/opp-service.js";
import org from "../../tools/org";
import bizflowLeft from "../../components/common/bizflowLeft.vue";
import bizflowTop from "../../components/common/bizflowTop.vue";
// import loadingPage from "../../components/common/loadingPage.vue";
// import bizAccess from "./biz-access";
// import custInfoModel from "@/business/businessFile//commonModules/commonBizNode/common/cust-info-model";
// import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";
export default {
  name: "bizFlow",
  componentName: "bizFlow",
  data () {
    return {
      groupConfig: null,      //分组配置数据（仅分组数据）
      groupDatas: null,       //分组数据（包括分组下的模块、字段数据）
      groupDatasTpl: null,    //分组数据模板
      oldGroupDatas: null,    //旧的分组数据（分组数据中基于取回的历史数据）
      bizData: null,          //账户和流水数据
      historyData: null,      //旧的账户和流水数据（基于取回的历史流水数据）
      oppBusiData: {          //业务页面间存放临时数据
        "ID_TYPE":"",
        "ID_CODE":"",
        "CUST_FNAME":"",
        "CUST_NAME":"",
        "USER_FNAME":"",
        "USER_NAME":"",
        "SUBJECT_IDENTITY": "0"
      },
      messageType: "loadFail",  //页面异常的提示信息
      messageText: "",
      messageTypeShow: false,   //页面加载异常显示页面的标志位
      leftStepArr:[],           //左边侧边栏的数据
      secondTopStepArr:[],      //顶部的二级导航
      messageBoxProps: {},
      leftButtonText:"资料提交",
      // leftStepIndex:0,
      isClickLeftStep:"",
      showButton: false,
      showJumpButton: false,
      noUpdateApptStatus:[],
      hasSave:false,//发现手机端登录，只需要暂存一次
      errTimes: 0,
    };
  },
  provide () {
    return {
      checkMobileLogin: this.checkMobileLogin,
    };
  },
  components: {
    TryAgain,
    // messageBox,
    // rejectRemarkTip,
    bizflowLeft,
    bizflowTop,
    // loadingPage,
  },
  created () {
    console.log("bizflow 进来了。。。");
  },
  mounted () {
    let oldData = this.$storage.getJsonSession(this.$definecfg.OPP_BUSI_DATA);
    if(oldData && !_.isEmpty(oldData)){
      this.oppBusiData = Object.assign(this.oppBusiData, oldData);
    }
    this.oppBusiData.busiCommonParams = this.$storage.getJsonSession(this.$definecfg.BUSI_COMM_PARAM_OBJS) || {};
    //初始化的时候，默认给页面刷新标识
    this.$store.commit(this.$types.UPDATE_PAGE_RELOAD, false);
    //监听刷新事件，增加提示
    window.hackBeforeunload = async e =>{
      this.$store.commit(this.$types.UPDATE_PAGE_RELOAD, true);
      consoleLog("beforeunload", this.oppBusiData);
      this.$storage.setSession(this.$definecfg.OPP_BUSI_DATA, this.oppBusiData);
      e.preventDefault();
      e.returnValue = "";
    };
    window.onbeforeunload =  window.hackBeforeunload;
    this.initPage().then(()=>{
      this.checkBizRouterShow();
      this.getChildernStep(this.nodeType);
    });
  },
  activated () {
    this.checkBizRouterShow();
  },
  deactivated () {},
  beforeDestroy (){
    //清除require缓存 保持重新加载
    if (this.bizConfig.disableCache) {
      let requireData = "";
      try {
        if (this.bizConfig.logicBusiCode) {
          requireData = require.resolve(`../../business/businessFile//${this.busiCode}/${this.bizConfig.logicBusiCode}.js`);
        } else {
          requireData = require.resolve(`../../business/businessFile//${this.busiCode}/${this.busiCode}.js`);
        }
      } catch (error) {
        requireData = "";
      }
      if (_.isNumber(requireData)) {
        delete require.cache[requireData];
      }
    }
    //清除监听事件
    window.onbeforeunload = null;
    this.stopInterVal();
  },
  beforeRouteEnter (to, from, next) {
    let r = {};
    if(to.name == "bizEntry") {
      //第一次跳转去的是bizEntry路由，重定向路径为bizflow，并携带参数
      r.path = to.path.split("/bizEntry/")[0];
      r.query = Object.assign({ "pageNum": to.params.pageNum }, to.query);
    } else if(to.name == "bizPage") {
      r.path = to.path.split("/bizPage/")[0];
      r.query = Object.assign({ "pageName": to.params.pageName }, to.query);
    } else if(to.name != "bizFlow") {
      r.path = to.path.split("/" + to.name)[0];
      r.query = Object.assign({ "module": to.name }, to.query);
    }

    if(!_.isEmpty(r)) {
      next(r);
    } else {
      next();
    }
  },
  beforeRouteUpdate (to, from, next) {
    let r = {};
    if(to.name == "bizEntry"
        && (to.params.busiCode != from.params.busiCode || to.params.userType != from.params.userType)) { // 业务发生变化，重新初始化
      r.path = to.path.split("/bizEntry/")[0];
      r.query = Object.assign({ "pageNum": to.params.pageNum }, to.query);
    } else if(to.name == "bizPage"
        && (to.params.busiCode != from.params.busiCode || to.params.userType != from.params.userType)) { // 业务发生变化，重新初始化
      r.path = to.path.split("/bizPage/")[0];
      r.query = Object.assign({ "pageName": to.params.pageName }, to.query);
    } else if(to.name != "bizFlow"
        && (to.params.busiCode != from.params.busiCode || to.params.userType != from.params.userType)) {
      r.path = to.path.split("/" + to.name)[0];
      r.query = Object.assign({ "module": to.name }, to.query);
    }

    if(!_.isEmpty(r)) {
      next(r);
    } else {
      next();
    }
  },
  props: ["busiCode", "userType"],
  computed: {
    cardData () {
      return this.$store.state.cardData;
    },
    apptStatus: function (){
      return this.$store.state.apptStatus;
    },
    oldBizData () {
      return this.$store.state.oldBizData;
    },
    qsVersionName (){
      return this.$bizcfg.getBizConfigName(this.$definecfg.QSJGDM_CONST[this.$basecfg.qsVersion]);
    },
    busiLogic () { //busiLogic业务逻辑数据体
      if(this.bizConfig.logicBusiCode){
        return require(`../../business/businessFile//${this.busiCode}/${this.bizConfig.logicBusiCode}.js`).default;
      }
      return require(`../../business/businessFile//${this.busiCode}/${this.busiCode}.js`).default;
    },
    bizConfig () {
      return this.$bizcfg.getBizConfig(this.busiCode, this.userType);
    },
    bizRouteTable () {
      return this.$store.state.bizRouteTable;
    },
    updateRouteTableFlag () {
      return this.$store.state.updateRouteTableFlag;
    },
    pageNum () {
      return "pageNum" in this.$route.query ? parseInt(this.$route.query.pageNum) : -1;
    },
    pageName () {
      return this.$route.query.pageName;
    },
    module () {
      return this.$route.query.module;
    },
    nodeType (){
      return this.$route.path.split("/")[4];
    },
    secondNodeType (){
      return "from" in this.$router.getCurrentRoute() ? this.$router.getCurrentRoute().from : "base";
    },
    stepIndex (){
      return this.$router.getCurrentRoute().stepIndex;
    },
    isShowPrev: function () { // 控制是否显示上一步
      if("isShowPrev" in this.$router.getCurrentRoute()){//如果路由配置了下一步的控制则以配置为准，否则根据页面下标计算
        return this.$router.getCurrentRoute().isShowPrev;
      }
      return this.$router.getCurrentRouteIndex() > this.getFirstWithIgnorePageIndex();
    },
    isShowNext: function () { // 控制是否显示保存还是下一步，默认显示保存按钮
      if("isShowNext" in this.$router.getCurrentRoute()){//如果路由配置了下一步的控制则以配置为准，否则根据页面下标以及流程状态计算
        return this.$router.getCurrentRoute().isShowNext;
      }
      // return this.canGoNext && [2, 11, 13, 14, 15, 17, 18].indexOf(this.apptStatus) !== -1;
      return true;
    },
    canGoNext: function () { // 控制是否显示保存还是下一步，默认显示保存按钮
      return this.$router.getCurrentRouteIndex() < this.getLastWithIgnorePageIndex();
    },
    isShowPageIndex: function (){ //获取
      if("isShowPageIndex" in this.$router.getCurrentRoute()){//如果路由配置了下一步的控制则以配置为准，否则根据页面下标计算
        return this.$router.getCurrentRoute().isShowPageIndex;
      }
    },
    isShowFlowLeft: function () {
      return this.$router.getCurrentRoute().isShowFlowLeft !== false;
    },
    isBizPage: function () {
      return this.$router.getCurrentRoute().path.includes("bizPage");
    },
    userInfo: function () {
      return this.$storage.getJsonSession(this.$definecfg.USER_INFO) || {};
    },
    customerInfo: function () {
      return this.$storage.getJsonSession(this.$definecfg.CUSTOMER_INFO) || {};
    },
    isShowButton: function () {
      let bSno = this.$storage.getSession(this.$definecfg.B_SNO);
      return bSno&&this.nodeType=="baseInfoNode";
    },
    openAcctType () {
      return this.$store.state.openAcctType;
    },
    disabledArray (){
      let arr = [];
      this.noUpdateApptStatus =  this.$syscfg.consts().ACCEPT_NO_UPDATE_APPT_STATUS;
      if(this.nodeType == "baseInfoNode"){
        this.noUpdateApptStatus =  this.$syscfg.consts().ACCEPT_NO_UPDATE_APPT_STATUS;
      }else if (this.nodeType == "imageUploadNode") {
        // 影像上传节点，旧版是控制了预审核后不允许修改
        this.noUpdateApptStatus = this.$syscfg.consts().IMGUPLOAD_NO_UPDATE_APPT_STATUS;
      }else if (this.nodeType == "formPrintNode") {
        // 打印节点，在途的可以修改的要校验，已完结/转移/作废 不校验
        this.noUpdateApptStatus = this.$syscfg.consts().FORMPRINT_NO_UPDATE_APPT_STATUS;
      }else if (this.nodeType == "videoWitnessInfoNode") {
        // 见证节点，在途的可以修改的要校验，已完结/转移/作废 不校验
        this.noUpdateApptStatus = this.$syscfg.consts().VIDEOWITNESS_NO_UPDATE_APPT_STATUS;
      }
      if(this.noUpdateApptStatus.includes(this.apptStatus)){
        arr.push({
          title:"当前流水状态不允许修改数据",
          key:"notUpdateAppt",
          type: "warning",
        });
      }
      if(!this.$store.state.permission.editAuth){
        arr.push({
          title:"无权限修改业务数据和影像数据",
          key:"noEditAuth",
          type: "warning",
        });
      }
      if(this.$store.state.mobileLogin){
        arr.push({
          title: "手机端已登录,无法在PC端继续修改数据,请前往手机端修改数据！如需强制修改数据,请点击‘退出手机登录’",
          confirmBtnTxt: "退出手机登录",
          type: "warning",
          key:"foribinMobileLogin",
          confirmedAction: function (){
            //调用接口 退出手机登录
            this.$syscfg.K_Request("F0000080",{});
            this.removeFlowTip("foribinMobileLogin");
          }
        });
      }
      return arr;
    }
  },
  methods: {
    async initPage (){
      let that = this;
      that.showLoading ("正在核对客户业务数据...");
      that.$store.commit(that.$types.UPDATE_ROUTE_TABLE_FLAG, false);           //更新刷新导航标志
      that.initData();
      let flag = await that.checkMobileLogin();
      this.startInterVal();
      //该项目支持刷新，所以刷新需要重新获取一次最新的业务流水数据
      consoleLog("bizflow 初始化 获取流水数据");
      await oppService.getBusiDataByApptSn(this.$store.state.apptSn);
      return  that.loadFlowInfo().then(() => {
        if ("beforeLoadBiz" in that.busiLogic) { // 请求业务相关数据
          consoleLog("bizflow 初始化 beforeLoadBiz");
          return that.busiLogic.beforeLoadBiz(this);
        }
      }).then(() => {
        return that.parseBizData(); // 解析复用历史流水及读卡数据
      }).then(() => {
        if ("afterLoadBiz" in that.busiLogic) { // 数据预处理
          consoleLog("bizflow 初始化 afterLoadBiz");
          return that.busiLogic.afterLoadBiz(that);
        }
      }).then(() => {
        that.showLoading(false);
        let currentIdx = that.$router.getCurrentRouteIndex();
        let firstIdx = that.getFirstShowPageIndex();
        let pathIdx = that.getShowPageIndexByPath();
        if(firstIdx > currentIdx || pathIdx != currentIdx) { // 当前节点可能被隐藏，需跳至下一个显示的节点
          let index = that.getNextShowPageIndex() > firstIdx ? that.getNextShowPageIndex() : firstIdx;
          let ip = that.$router.getRoute(index).path;
          if(ip.indexOf("/bizFlow/") >= 0 && ip.indexOf("/bizEntry/") > 0) { // 新页面为bizEntry时，此时需要用业务代码重新initPage，以防业务代码发生了变化
            that.$store.commit(that.$types.UPDATE_BIZ_ROUTE_INDEX, index);
            that.$router.push(ip.replace("/bizEntry/", "?pageNum="));
          } else if(ip.indexOf("/bizFlow/") >= 0 && ip.indexOf("/bizPage/") > 0) { // 新页面为bizEntry时，此时需要用业务代码重新initPage，以防业务代码发生了变化
            that.$store.commit(that.$types.UPDATE_BIZ_ROUTE_INDEX, index);
            that.$router.push(ip.replace("/bizPage/", "?pageName="));
          } else {
            that.$router.goRoute(index, that.$route.query);
          }
        } else {
          that.$router.goRoute(currentIdx, that.$route.query);
        }
        this.getChildernStep(this.nodeType);
      }).catch(err => {
        consoleError("-------------BizFlow出错了--------------", err);
        that.messageType = "loadFail";
        that.messageTypeShow = true;
        that.showLoading(false);
        that.messageText = err && err.toString() || "";
      });
    },
    startInterVal (){
      let that = this;
      this.stopInterVal();
      window.checkMobileInterval = setInterval(() => {
        that.checkMobileLogin();
      }, 10000);
    },  
    stopInterVal (){
      clearInterval(window.checkMobileInterval);
      window.checkMobileInterval = null;
    },
    checkMobileLogin (){
      let that = this;
      this.$syscfg.K_Request("F0000084").then(res=>{
        if(_.get(res,"Data[0].tokenId")){
          //手机端已登录
          this.$store.commit(this.$types.UPDATE_MOBILE_LOGIN, true);
          this.$store.commit(this.$types.UPDATE_LAST_MOBILE_LOGIN, true);
          //监听到手机端登录就把数据暂存到服务器,，只需要暂存一次
          if(!this.hasSave){
            //如果当前流水为空则不暂存，说明三要素都没有,修复pc生成一笔空白流水，手机端采集营业执信息后下一步后会生成第二笔流水
            if(!this.$store.state.bSno){
              consoleLog("手机端已登录，不触发暂存");
              //暂存只能要么在手机端登录就触发，要么就一直不触发等到下一轮手机退出登录手机登录再触发。不能在手机端登录之后过一段时间触发，不然这个时候手机端已经采集了数据，
              // pc暂存会覆盖手机数据，所以这里虽然不触发，但是也要this.hasSave改为true，防止其他开发不了解情况误保存了流水又没有退出手机登录，触发了暂存
              this.hasSave = true;
              return;
            }
            try{
              this.stopInterVal();
              if(!_.get(this, "$refs.routerView.next")){
                consoleLog("手机端已登录，不触发暂存");
                this.startInterVal();
                return;
              }
              consoleLog("手机端已登录，触发暂存");
              return  this.$refs && this.$refs.routerView && this.$refs.routerView.next && this.$refs.routerView.next(false, false).then(res=>{
                consoleLog("暂存成功",res);
              }).finally(()=>{
                this.hasSave = true;
                this.stopInterVal();
                this.startInterVal();
              });
            }catch(err){
              this.stopInterVal();
              this.startInterVal();
              consoleLog("手机端已登录,暂存失败",err);
              this.hasSave = true;
            }
          }
          return true;
        }else{
          //手机端未登录 重置暂存标记开关
          this.hasSave = false;
          this.$store.commit(this.$types.UPDATE_MOBILE_LOGIN, false);
          if(this.$store.state.lastMobileLogin===true){
            this.$store.commit(this.$types.UPDATE_LAST_MOBILE_LOGIN, false);
            this.$store.commit(this.$types.UPDATE_PAGE_RELOAD, true);
            consoleLog("手机端退出登录，触发刷新");
            //如果上一次是手机登录状态，这一次手机退出登录，那么需要重新加载页面
            that.alert({
              messageText:"数据已变更，需要刷新页面获取最新数据",
              confirmedAction:async ()=>{
                this.forceRefresh();
              }
            });
          }
          return false;
        }
      }).catch(err=>{
        that.errTimes++;
        if(that.errTimes >= 10){
          alert("服务器异常，无法获取手机端登录状态");
          this.stopInterVal();
        }
      });
    },  
    //强制刷新页面
    async forceRefresh (){
      //手动保存数据然后刷新
      this.$storage.setSession(this.$definecfg.OPP_BUSI_DATA, this.oppBusiData);
      // 暂时关闭拦截刷新
      window.onbeforeunload = false;
      consoleLog("先暂存再刷新");
      //先保存页面数据
      // let flag = await this.$refs.routerView.next(false, false);
      // if(this.groupDatas){
      //   try {
      //     this.$storage.setLocal(this.$definecfg.TMP_GROUP_DATAS, this.groupDatas);
      //   }catch(err){
      //     consoleLog("缓存保存失败", err);
      //   }
      // }
      //强制页面刷新
      location.reload();
      consoleLog("强制页面刷新");
    },
    loadFlowInfo () {
      let reqList = [
        this.getGroupCfg(this.busiCode, this.userType),
        this.getPreCfg(this.busiCode, this.userType) 
      ];
      var that = this;

      return this.$syscfg.K_Request_ALL(reqList).then(res => {
        
        let groupCfg = res[0],
          groupDatas = res[1];

        if (groupCfg.Code != "0") {
          throw groupCfg.Msg;
        }
        if (groupDatas.Code != "0") {
          throw groupDatas.Msg;
        }

        if(groupDatas.Data.length == 0) {
          this.messageType = "noInfo";
          this.messageTypeShow = true;
          throw "当前业务无预录入页面配置信息";
        }

        // 赋值分组配置数据
        this.groupConfig = groupCfg.Data;

        var sysCommonParam = that.$storage.getJsonSession(that.$definecfg.SYS_COMM_PARAM_OBJS);
        var voiceInputArr = _.get(sysCommonParam,"APP_VOICE_INPUT_VALUE","").split(",");
        // 初始化页面渲染数据结构
        groupDatas = groupDatas.Data[0];
        let groupPage = {};
        this.groupConfig.sort(this.by("GROUP_SEQ"))
          .map(group => {
            if(group.BUSI_PLAT && group.BUSI_PLAT.split(",").indexOf(this.$basecfg.bizPlatform) == -1)
              return; // 过滤掉不是当前业务平台的配置

            let groupDatatemp = groupDatas[group.GROUP_ID];
            let modules = {};
            groupPage[group.GROUP_ID] = [];
            Object.values(groupDatatemp)
              .map(groupArr => { return groupArr[0]; })
              .sort(this.by("MODULE_SEQ"))
              .map(item => {
                if((item.GROUP_BUSI_PLAT&& item.GROUP_BUSI_PLAT.split(",").indexOf(this.$basecfg.bizPlatform) == -1)
                    || (item.MODULE_BUSI_PLAT && item.MODULE_BUSI_PLAT.split(",").indexOf(this.$basecfg.bizPlatform) == -1))
                  return; // 过滤掉不是当前业务平台的配置

                let fields_temp = {};
                // 判断模块分组的字段数量（默认两个字段占一行，标题占一行）
                groupPage[item.GROUP_ID].push({
                  "group_title": group.GROUP_TITLE,
                  "group": item.GROUP_ID,
                  "module" : item.MODULE_ID,
                  "count" : _.ceil(_.keys(item.FIELDS).length / 2) + 1});

                Object.values(item.FIELDS)
                  .sort(this.by("FIELD_SEQ"))
                  .map(item1 => {
                    if(item1.FIELD_BUSI_PLAT && item1.FIELD_BUSI_PLAT.split(",").indexOf(this.$basecfg.bizPlatform) == -1)
                      return; // 过滤掉不是当前业务平台的配置

                    //如果语音输入数组中包含 该业务的此字段，则赋值IS_SHOW_VOICEINPUT_BUTTON = true;
                    _.indexOf(voiceInputArr, item1.FIELD_ID)>-1?item1.IS_SHOW_VOICEINPUT_BUTTON = true :"";

                    //TODO:DEBUG
                    // item1.FIELD_REQUIRED = '0'
                    item1["GROUP_ID"] = item.GROUP_ID;
                    item1["showerr"] = false;
                    item1["showchange"] = false;
                    item1["FIELD_ADDITION"] = {};
                    item1["IS_SHOW_BUTTON"] = false;
                    item1["FIELD_BUTTON_TXT"] = "";
                    item1["component"] = "";
                    item1["FIELD_AUTOSIZE"] = false;
                    item1["SUFFIX_ICON"] = "";
                    item1["showDictItem"] = "1";
                    item1["promptValue"] = "";
                    item1["BUTTON_ENABLE"] = false;
                    item1["MESSAGE_REMINDER"] = "";
                    item1["DATA_SOURCE"] = "";
                    item1["isLongItem"] = false;
                    if(item1.FIELD_TYPE == "addressInput") {
                      item1["showRegionSelector"] = true;
                      item1["showCountrySelector"] = false; // 默认隐藏国家选择
                    }
                    if(item1.FIELD_TYPE == "telephone"){
                      item1["telPhoneType"] = 0;
                    }
                    if(item1.FIELD_TYPE == "normalinput"){
                      item1["hasRsaPwd"] = false;
                    }
                    fields_temp[item1.FIELD_ID] = item1;
                    //每个字段都进行org_code过滤
                    let custOrgCode = this.customerInfo && this.customerInfo.INT_ORG ? this.customerInfo.INT_ORG : "";
                    custOrgCode = custOrgCode != "" ? custOrgCode : this.userInfo.ORG_CODE;
                    let dicts = _.filter(item1.FIELD_DICT_NAME, (item) => {
                      return org.transOrgCode(custOrgCode) == item.ORG_CODE;
                    });
                    if(dicts.length){
                      item1.FIELD_DICT_NAME = dicts;
                    }
                  });
                item.FIELDS = fields_temp;
                item["MODULE_DELETE"] = "0"; // 初始默认所有组删除按钮隐藏
                item["MODULE_NUM"] = ""; // 初始化模块序号为空（后面从相应数据中取对应序号，传给一柜通用）
                item["MAX_LENGTH"] ="";//控制添加模块个数
                item["MODULE_CUSTOMIZE"] = "";
                item["MODULE_DISABLED"] = "0";// 初始默认模块不置灰
                item["MODULE_DOWNLOAD"] = "0";
                item["MODULE_IMPORT"] = "0";
                // if(this.busiCode in moduleConfig
                //     && this.userType in moduleConfig[this.busiCode]
                //     && item.MODULE_ID in moduleConfig[this.busiCode][this.userType])
                //   item = Object.assign(item, moduleConfig[this.busiCode][this.userType][item.MODULE_ID]);
                modules[item.MODULE_ID] = [item];
              });
            groupDatas[group.GROUP_ID] = modules;
          });

        this.groupDatas = groupDatas;
        this.groupDatasTpl = _.cloneDeep(groupDatas);
        this.oldGroupDatas = {};
        this.bizData = {};
        this.historyData = {};
      });
    },
    parseBizData: async function () {
      Object.assign(this.oldGroupDatas, _.cloneDeep(this.groupDatas)); // 保存历史数据用于还原和新旧值对比
      if(!_.isEmpty(this.oldBizData)) {
        // let bdata = await oppService.parseToVtmBusiData(_.cloneDeep(this.oldBizData));
        // let bdata = _.cloneDeep(this.oldBizData);
        // this.bizData = Object.assign(this.bizData, bdata);
        let busiInfo = this.$storage.getJsonSession(this.$definecfg.BUSI_INFO);
        this.historyData = Object.assign(this.historyData, busiInfo);
        // @qgj: 框架不做统一回填，各模块单独调用回填逻辑。
        // this.parseOldBiz(bdata) 
        //检查路由并更新TRAVEL
        if (!_.isEmpty(this.historyData.TRAVEL)) {
          let newTravel = {},
            travelList = Object.values(_.cloneDeep(this.historyData.TRAVEL));
          travelList.map( t => {
            let route = _.find(this.bizConfig.bizRoutes, route => route.name === t.MODULE_NAME);
            if(!!route) {
              let routerIndex = this.$router.getRouteIndex(route.name);
              routerIndex > -1 && (newTravel[routerIndex] = t);
            }
          });
          this.$set(this.historyData, "TRAVEL", newTravel);
        }
      }
      
      if(this.cardData) { //如果读卡资料cardData有值,则进行赋值
        this.parseCardData(this.cardData);
      }
    },
    prevStep () {
      let idx = this.getPrevShowPageIndex();
      if(idx !== -1) {
        consoleLogNow("bizFlow prevStep 点击了上一步");

        this.$router.goRoute(idx);
      } else {
        consoleLog("已到头部");
      }
    },
    nextStep () {
      let idx = this.getNextShowPageIndex();
      if(idx !== -1) {
        consoleLogNow("bizFlow nextStep 点击了下一步");
        this.$router.goRoute(idx);
        //如果有导航栏 则下一步的时候刷新导航栏状态
        if (this.secondTopStepArr && this.secondTopStepArr.length > 1) {
          this.secondTopStepArr = this.getTopStepStatus(this.secondTopStepArr);
        }else{
          this.leftStepArr = this.getLeftStepStatus(this.leftStepArr);
        }
        // 是否显示提交按钮
        let flag = true;
        _.each(this.historyData.TRAVEL, obj => {
          if (obj.REJECT == "2") {
            flag = false;
            return false;
          }
        });
        let bSno = this.$storage.getSession(this.$definecfg.B_SNO);
        if (bSno&&this.nodeType == "baseInfoNode"&&flag) {
          this.showButton = true;
        } else {
          this.showButton = false;
        }
      } else {
        consoleLog("已到尾部");
      }
    },    
    changeToplinkName (val) {
      this.isClickLeftStep = "";
    },
    async save (_that, params, baseData={}) { // _that 需使用各个页面当前的 this
      // 执行页面保存前的处理函数
         
      this.showLoading("正在核对您提交的业务数据......");
      // 提交请求体外层参数，某些业务需要在beforeSave中改变baseData
      //默认不变更见证流水状态
      let apptStatus = this.apptStatus || "1";
      if(this.$store.state.mobileLogin && this.hasSave){
        //手机端已登录时只能更新nodecode，不能更新流水数据，防止覆盖手机端数据
        return oppService.updateNodeCode().catch((err) => {
          throw err;
        }).finally(()=> {
          this.showLoading(false);
        });;
      }
      return  Promise.all([
        "beforeSave" in _that.busiLogic && _.isFunction(_that.busiLogic.beforeSave) && this.beforeSaveExt(_that.busiLogic.beforeSave, _that, params, baseData, apptStatus) || true
      ]).then(() => {
        return this.saveBizData(params, baseData, apptStatus);
      }).then((res) => {
        return Promise.all([ // 处理请求后的逻辑
          "afterSave" in _that.busiLogic && _.isFunction(_that.busiLogic.afterSave) && _that.busiLogic.afterSave(_that, res, null) || true
        ]).then(() => {
          this.isShowJumpButton();
          return res;
        });
      }).catch((err) => {
        if (err == "preventNextStep") {
          // 阻止跳转下一页
          throw err;
        };
        console.trace(err);
        consoleError("BizFlow保存出出错了", err);
        // let str = err.message ? err.message : Object.prototype.toString.call(err) == "[object Object]" ? JSON.stringify(err) : err;
        // str.length && str.length > 100 && (str = str.substring(0, 100));
        // consoleError("保存出错了:" + str);
        throw err;
      }).finally(()=> {
        this.showLoading(false);
        //    mask.close()
      });
    },
    // beforeSave封装，使得在beforeSave中的“异常代码”能够在bizFlow捕获到，以正确关掉loadingPage
    beforeSaveExt (calback, _that, params, baseData){
      try{
        return calback(_that, params, baseData);
      }catch(err){
        return Promise.reject(err);
      }
    },
    saveBizData (params,baseData,apptStatus ) {
  
      // params.BUSI_COMM_PARAM = this.oppBusiData.busiCommonParams;
      let routerIndex = this.$router.getCurrentRouteIndex(),travel = {};
      let targetRouter = this.$router.getRoute(routerIndex)||{};
      travel[routerIndex] = {
        MODULE_NAME:targetRouter.name||"",
        REJECT:"0",
        MODULES: "modules" in targetRouter?targetRouter.modules:"",
        YGT_MODULE:"ygtModule" in targetRouter?targetRouter.ygtModule:"",
      };
      // params.TRAVEL = this.historyData.TRAVEL ? Object.assign({},this.historyData.TRAVEL, travel) : travel;
      // params.routerIndex = routerIndex.toString();
      return oppService.saveBizData(params,baseData,apptStatus).then((response) => {
        if(response.Code == "0") {
          let busiInfo = this.$storage.getJsonSession(this.$definecfg.BUSI_INFO);
          this.historyData = Object.assign(this.historyData, busiInfo);
          return response;
        } else {
          throw response.Msg;
        }
      });
    },
    async updateHistoryData (cb) {
      let flag = await oppService.getBusiDataByApptSn(this.$store.state.apptSn);
      //不能直接将返回的ygt数据结构跟历史数据合并，否则可能会造成数据丢失
      let vtmData = this.$storage.getJsonSession(this.$definecfg.BUSI_INFO);
      //更新historydata的值
      this.historyData = Object.assign(this.historyData, vtmData);
      cb&&cb(flag!==false);
    },
    saveApptBizData (params) {
      return oppService.saveApptBizData(params).then((response) => {
        if (response.Code == "0") {
          if (response.Data.length > 0) {
	          //不能直接将返回的ygt数据结构跟历史数据合并，否则可能会造成数据丢失
            let vtmData = this.$storage.getJsonSession(this.$definecfg.BUSI_INFO);
            //ljc 更新保存的历史流水的 oldBizData 避免影像上一步回填上一次的历史流水信息
            this.$store.commit(this.$types.UPDATE_OLD_BIZ_DATA, vtmData);
            //更新historydata的值
            this.historyData = Object.assign(this.historyData, vtmData);
            
          }
          return response;
        } else {
          throw response.Msg;
        }
      });
    },
    // 获取分组配置
    getGroupCfg: function (busiCode, userType) {
      return this.$syscfg.K_Request("F0000027", {
        BUSI_CODE: busiCode,
        USER_TYPE: userType
      });
    },
    // 获取预录入字段配置（分组、模块、字段）
    getPreCfg: function (busiCode, userType, groupId) {
      return oppService.F0000028({
        BUSI_CODE: busiCode,
        USER_TYPE: userType
      });
    },
    getShowPageIndexByPath: function () {
      // 返回请求路由跳转过来的不隐藏页数
      for(let i = 0; i < this.bizRouteTable.length; i++) {
        if(this.bizRouteTable[i].show && !this.isAllHideModule(i)
          && (this.bizRouteTable[i].path == this.$route.path
                || ("pageNum" in this.$route.query && this.bizRouteTable[i].path == this.$route.path + "/bizEntry/" + this.$route.query.pageNum)
                || ("pageName" in this.$route.query && this.bizRouteTable[i].path == this.$route.path + "/bizPage/" + this.$route.query.pageName))
                || ("module" in this.$route.query && this.bizRouteTable[i].path == this.$route.path + "/" + this.$route.query.module)) {
          return i;
        }
      }
      return -1;
    },
    getFirstShowPageIndex: function () {
      // 返回路由中第一个不隐藏的页数
      for(let i = 0; i < this.bizRouteTable.length; i++) {
        if(this.bizRouteTable[i].show && !this.isAllHideModule(i)) {
          return i;
        }
      }
      return -1;
    },
    getLastShowPageIndex: function () {
      // 返回路由中所有模块中最后一个都不隐藏的页数
      for(let i = this.bizRouteTable.length - 1; i >= 0; i--) {
        if(this.bizRouteTable[i].show && !this.isAllHideModule(i)) {
          return i;
        }
      }
      return -1;
    },
    getFirstWithIgnorePageIndex: function () {
      // 返回路由中第一个不隐藏且忽略上一步的页数
      for(let i = 0; i < this.bizRouteTable.length; i++) {
        if(this.bizRouteTable[i].show && !this.bizRouteTable[i].ignorePrev && !this.isAllHideModule(i)) {
          return i;
        }
      }
      return -1;
    },
    getLastWithIgnorePageIndex: function () {
      // 返回路由中所有模块中最后一个都不隐藏且忽略下一步的页数
      for(let i = this.bizRouteTable.length - 1; i >= 0; i--) {
        if(this.bizRouteTable[i].show && !this.bizRouteTable[i].ignoreNext && !this.isAllHideModule(i)) {
          return i;
        }
      }
      return -1;
    },
    getPrevShowPageIndex: function () {
      let idx = this.$router.getCurrentRouteIndex();
      for(let i = idx - 1; i >= 0; i--){
        if(this.bizRouteTable[i].show && !this.bizRouteTable[i].ignorePrev && !this.isAllHideModule(i)) {
          return i;
        }
      }
      return -1;
    },
    getNextShowPageIndex: function () {
      let idx = this.$router.getCurrentRouteIndex();
      for(let i = idx + 1; i < this.bizRouteTable.length; i++) {
        if(this.bizRouteTable[i].show && !this.bizRouteTable[i].ignoreNext && !this.isAllHideModule(i)) {
          return i;
        }
      }
      return -1;
    },
    parseOldBiz: function (bdata) { // 解析历史流水数据 统一用同一个解析函数
      this.$blMethod.parseOldBiz(this.groupDatas, bdata);
    },
    parseCardData: function (cardData) { // 解析身份证读卡数据
      for(let gl in this.groupDatas) {
        if("CUST_BASIC_INFO" in this.groupDatas[gl]) {
          let mda = this.groupDatas[gl]["CUST_BASIC_INFO"];
          for(let i = 0; i < mda.length; i++) {
            let mdda = mda[i];
            for(let fl in cardData) {
              if(fl in mdda["FIELDS"]) {
                let field = mdda["FIELDS"][fl];
                field["FIELD_CONTROL"] = "2";
                field["DEFAULT_VALUE"] = cardData[fl];
                if(fl == "SEX" || fl == "NATIONALITY"){
                  _.filter(field.FIELD_DICT_NAME, (item) => {
                    if(item.DICT_ITEM_NAME == cardData[fl])
                      field["DEFAULT_VALUE"] = item.DICT_ITEM;
                  });
                }else if(fl == "CUST_FNAME"){
                  mdda["FIELDS"]["CUST_FNAME"]["DEFAULT_VALUE"] = cardData[fl];
                  mdda["FIELDS"]["CUST_FNAME"]["FIELD_CONTROL"] = "2";
                }else if(fl == "USER_FNAME"){
                  mdda["FIELDS"]["USER_FNAME"]["DEFAULT_VALUE"] = cardData[fl];
                  mdda["FIELDS"]["USER_FNAME"]["FIELD_CONTROL"] = "2";
                }else if(fl == "ID_EXP_DATE" && cardData[fl].indexOf("长期") != -1){
                  mdda["FIELDS"]["ID_EXP_DATE"]["DEFAULT_VALUE"] = "30001231";
                }
              }
            }
          }
          break;
        }
      }
    },
    by: function (name) {
      // 用于数组字典排序
      return function (o, p) {
        var a, b;
        if (typeof o === "object" && typeof p === "object" && o && p) {
          a = o[name];
          b = p[name];
          if (a === b) {
            return 0;
          }
          a = parseInt(a);
          b = parseInt(b);
          return a < b ? -1 : 1;
        } else {
          throw "error";
        }
      };
    },
    //返回true 表明指定的页数里所有模块都是隐藏的
    isAllHideModule: function (index){
      let route = {};
      if(index < this.bizRouteTable.length && "modules" in this.bizRouteTable[index] &&  this.bizRouteTable[index]["modules"].length && this.groupDatas) {
        let routerBiz = this.bizRouteTable[index].path&&this.bizRouteTable[index].path.split("/")[2];
        if(!routerBiz||routerBiz!=this.busiCode){
          return ;
        }
        route = this.bizRouteTable[index];

        let totalMods = 0;
        let hideMods = 0;
        for(let v in route.modules) {
          let mods = this.groupDatas[route.group][route.modules[v]];
          for(let md in mods){
            totalMods++;
            if(mods[md].MODULE_CONTROL == "0"){
              hideMods++;
            }
          }
        }

        if(totalMods == hideMods) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    refreshPage: function (){
      this.messageTypeShow = false;
      this.initPage();
    },
    initData: function (){
      // 重置初始化数据
      this.groupConfig = null;      //分组配置数据（仅分组数据）
      this.groupDatas= null;        //分组数据（包括分组下的模块、字段数据）
      this.groupDatasTpl= null;     //数据模板
      this.oldGroupDatas= null;     //旧的分组数据（分组数据中基于取回的历史数据）
    },
    //检查当前路由节点的默认隐藏显示逻辑
    checkBizRouterShow (){
      // if(this.customerInfo.USER_TYPE != "0") {
      //   let ORG_TAX_INFO = bizPublicSaveMethod.getModuleObjctFoyKey(this, "ORG_TAX_INFO");
      //   let ORG_PASSIVE_INFO = bizPublicSaveMethod.getModuleObjctFoyKey(this, "ORG_PASSIVE_INFO");
      //   let CONTROLLER_TAX_INFO = _.get(this, "oppBusiData.newControllerTaxInfo", []);

      //   let TAX_RESIDENT_TYPE = _.get(ORG_TAX_INFO,"TAX_RESIDENT_TYPE","");
      //   let PASSIVE_NFE = _.get(ORG_PASSIVE_INFO,"PASSIVE_NFE","");
        
      //   if(TAX_RESIDENT_TYPE == "1" && PASSIVE_NFE == "3" || TAX_RESIDENT_TYPE == "5") {
      //     this.$router.hideRoute("税收居民基本信息");
      //     this.$router.hideRoute("税收居民国/地区信息");
      //   } else if(TAX_RESIDENT_TYPE == "1" && PASSIVE_NFE == "1") {
      //     this.$router.hideRoute("税收居民国/地区信息");
      //   }
        
      //   if(PASSIVE_NFE && PASSIVE_NFE != "3" && !_.isEmpty(CONTROLLER_TAX_INFO) && _.find(CONTROLLER_TAX_INFO, item => !_.isEmpty(item))) {
      //     this.$router.showRoute("控制人涉税声明信息");
      //   } else {
      //     this.$router.hideRoute("控制人涉税声明信息");
      //   }
      //   this.$router.hideRoute("资产信息");
      //   this.$router.hideRoute("控制人涉税居民身份信息");
      //   this.$router.hideRoute("控制人出生信息");
      //   this.$router.hideRoute("控制人税收联系地址");
      //   this.$router.hideRoute("控制人税收信息");
      // }
    },
    //获取左侧列表数量
    getChildernStep (val){
      if(val){
        this.leftStepArr = [];let leftObj = {};
        for(let i = 0; i < this.bizRouteTable.length; i++) {
          let rc = _.split(this.bizRouteTable[i].path, "/")[4];
          if(val==rc){
            if(!this.bizRouteTable[i].from&&this.bizRouteTable[i].show){
              this.leftStepArr.push(this.bizRouteTable[i]);
            }else if(!leftObj[this.bizRouteTable[i].from]&&this.bizRouteTable[i].show){
              leftObj[this.bizRouteTable[i].from]  = {fromParent:this.bizRouteTable[i].from,name:this.bizRouteTable[i].fromName,show:true};
              this.leftStepArr.push(leftObj[this.bizRouteTable[i].from]);
            }
          }
        }
        this.leftStepArr = this.getLeftStepStatus(this.leftStepArr);
        this.leftStepArr.length&&this.getSecondChildernStep(this.secondNodeType);
      }
    },
    //更新左侧列表状态
    getLeftStepStatus (leftArr){
      let that = this;
      // let busiInfo = this.$storage.getJsonSession(this.$definecfg.BUSI_INFO);
      // let stepPassObj = busiInfo?this.nodeType=="baseInfoNode"&&busiInfo.CUST_INFO&&busiInfo.CUST_INFO.TRAVEL?busiInfo.CUST_INFO.TRAVEL:(busiInfo.TRAVEL||{}): (this.oppBusiData.newBusiData && this.oppBusiData.newBusiData.TRAVEL||{});
      let stepPassObj = this.historyData.TRAVEL||{};
      let isCheckedReject = this.$store.state.rejectStatus;
      let leftArrTemp = _.cloneDeep(leftArr);
      if(isCheckedReject == "1"){
        let rejectModule = that.$storage.getJsonSession(that.$definecfg.REJECT_MODULE);
        //驳回的业务，配置页面禁灰非驳回模块
        let tempArr = _.compact(_.map(rejectModule, "MODULES").join().split(","));
        for (let gk in that.groupDatas) {
          for (let md in that.groupDatas[gk]) {
            if(tempArr && tempArr.length && _.indexOf(tempArr,md) == -1){
              that.groupDatas[gk][md][0].MODULE_ASH = true;
            }
          }
        }
        // 主要是为了处理机构涉税的控制人涉税信息
        let groupIds = _.map(rejectModule, "YGT_MODULE");
        // 机构涉税 如果驳回的模块包含 涉税模块 则控制人涉税不进行置灰
        if (_.indexOf(groupIds, "TAX_INFO") > -1) {
          if (that.userType == "1") {
            let controllerTax = "CONTROLLER_TAX_INFO";
            for (let md in that.groupDatas[controllerTax]) {
              that.groupDatas[controllerTax][md][0].MODULE_ASH = false;
            }
          }
        }
      }

      _.each(leftArrTemp,(item)=>{
        // let rc = _.split(item.path, '/')[6];
        let status = "success";
        item.upstatus = status;
        if(!item.fromParent){
          let routerIndex = this.$router.getRouteIndex(item.path);
          if(!stepPassObj[routerIndex]){
            status = "";
          }else if(stepPassObj[routerIndex].REJECT=="1"){
            status = "reject";
          }else if(stepPassObj[routerIndex].REJECT=="2"){
            status = "fail";
          }
          this.$set(item, "upstatus", status);

          return leftArr;
        }
        for(let index=0;index<that.bizRouteTable.length;index++){
          if(that.bizRouteTable[index].from===item.fromParent&&that.bizRouteTable[index].show){
            if(!stepPassObj[index]){
              status = "";
            }else if (stepPassObj[index].REJECT=="2") {
              status = "fail";
            }else if(stepPassObj[index].REJECT=="1"){
              status = "reject";
              break;
            }
          }
        }
        this.$set(item, "upstatus", status);
      });
      return leftArrTemp;
    },
    travelChange (flag, routerIndexArr = []) {
      let bSno = this.$storage.getSession(this.$definecfg.B_SNO);
      if (bSno && this.nodeType == "baseInfoNode" && flag) {
        this.showButton = true;
      } else {
        this.showButton = false;
      }
      if (!flag) {
        _.each(this.secondTopStepArr, item => {
          let routerIndex = this.$router.getRouteIndex(item.name);
          if (routerIndexArr.includes(routerIndex)) {
            item.status != "reject" && (item.status = "");
          }
        });
      } else {
        _.each(this.secondTopStepArr, item => {
          let routerIndex = this.$router.getRouteIndex(item.name);
          if (routerIndexArr.includes(routerIndex)) {
            item.status != "reject" && (item.status = "success");
          }
        });
      }
      this.leftStepArr = this.getLeftStepStatus(this.leftStepArr);
    },
    updateLeftStatusByRouter (flag, routerIndexArr = []) {
      if (!flag) {
        _.each(this.leftStepArr, item => {
          let routerIndex = this.$router.getRouteIndex(item.name);
          if (routerIndexArr.includes(routerIndex)) {
            item.upstatus != "reject" && (item.upstatus = "");
            this.historyData.TRAVEL && this.historyData.TRAVEL[routerIndex] &&  delete this.historyData.TRAVEL[routerIndex];
          }
        });
      } else {
        _.each(this.leftStepArr, item => {
          let routerIndex = this.$router.getRouteIndex(item.name);
          if (routerIndexArr.includes(routerIndex)) {
            item.upstatus != "reject" && (item.upstatus = "success");
          }
        });
      }
      //this.leftStepArr = this.getLeftStepStatus(this.leftStepArr)
    },
   
    //更新顶部导航状态
    getTopStepStatus (secondTopStepArr){
      let secondTopStepArrTpl = _.cloneDeep(secondTopStepArr);
      let stepPassObj = this.historyData.TRAVEL||{};
      _.each( secondTopStepArrTpl,item=>{
        let routerIndex = this.$router.getRouteIndex(item.name);
        // item.status = stepPassObj[routerIndex]&&stepPassObj[routerIndex].REJECT;
        if(stepPassObj[routerIndex]){
          if(stepPassObj[routerIndex].REJECT=="1"){
            item.status = "reject";
          } else if (stepPassObj[routerIndex].REJECT == "2") {
            //同步模块信息改变了没有保存的状态
            item.status = "";
          }else{
            item.status = "success";
          }
        }
      });
      return secondTopStepArrTpl;
    },
    getSecondChildernStep (val){
      this.secondTopStepArr = [];
      for(let i = 0; i < this.bizRouteTable.length; i++) {
         
        if(val==this.bizRouteTable[i].from&&this.bizRouteTable[i].show!==false) {
          this.secondTopStepArr.push(this.bizRouteTable[i]);
        }
        
      }
      this.secondTopStepArr = this.getTopStepStatus(this.secondTopStepArr);
    },
    //点击资料提交按钮
    tackClick (){
      let pathName = "";
      let currentIndex = this.$router.getCurrentRouteIndex();
      let target = _.find(this.bizRouteTable,(item,index)=>{
        let tagNodeType = item.path.split("/")[4];
        return index>currentIndex&&tagNodeType!=this.nodeType;
      });
      pathName = target&&target.name;
      //此处this.isClickLeftStep = pathName; 此句话表示保存当前模块并跳转至下一节点，其中pathName为下一节点的路由
      this.isClickLeftStep = pathName;
      // pathName&&this.$router.goRoute(pathName);
    },
    //是否显示跳过按钮
    isShowJumpButton () {
      let that = this;
      let isOpenAcct = that.$storage.getJsonSession(that.$definecfg.IS_OPEN_ACCT_BIZ);
      if (isOpenAcct == "0") {
        that.showJumpButton = false;
        return;
      }
      let busiCommonParams = that.$storage.getJsonSession(that.$definecfg.BUSI_COMM_PARAM_OBJS) || {};
      let isShowSkipButton = busiCommonParams.IS_SHOW_SKIP_BUTTON || "0";
      let bSno = that.$storage.getSession(that.$definecfg.B_SNO) || "";
      that.showJumpButton = isShowSkipButton == "1" ? true : false;
      if (["V9996", "V9998", "V9997"].indexOf(that.busiCode) == -1 || !_.isEmpty(bSno)) {
        that.showJumpButton = false;
        return;
      }
      if (!that.showJumpButton) {
        return;
      }
        
      let groupDatasTpl = _.cloneDeep(that.groupDatas);
      let err = [];
      //跳过前进行数据处理
      return  Promise.all([
        "beforeSkipBiz" in that.busiLogic && _.isFunction(that.busiLogic.beforeSkipBiz) && that.busiLogic.beforeSkipBiz(that, groupDatasTpl) || true
      ]).then( (res) => {
        if (_.includes(res, false)) {
          that.showJumpButton = false;
          return;
        }
        _.each(groupDatasTpl, (groupData, groupId) => {
          _.each(groupData, (modules, moduleId) => {
            _.each(modules, (moduleItem) => {
              if (moduleItem.MODULE_CONTROL != "1") {
                return true;
              }
              let fields = moduleItem.FIELDS;
              _.each( fields, (field) => {
                let flag = this.$blMethod.validateField(that, field);
                if (!flag) {
                  err.push({groupId: groupId, moduleData: moduleItem, field: field});
                }
              });
            });
          });
        });
        if (err.length > 0) {
          let errFieldTexts = [];
          _.each(err, errItem => {
            errFieldTexts.push(errItem.field.FIELD_TITLE);
          });
          // alert("'" + errFieldTexts.join('、') + "'等字段输入错误或必填未填写，不允许跳过");
          that.showJumpButton = false;
          return;
        }
        let isShowRestore = that.$find("bizEntry").isShowRestore;
        if (isShowRestore) {
          that.showJumpButton = false;
          // alert("当前页面有字段变更，不允许跳过");
          return;
        }
      }).catch( err => {
        alert(err);
      });
    },
    //点击跳过按钮
    jumpClick () {
      // let that = this;
		
      // let tempCustInfo = {
      //   BASIC_INFO: that.customerInfo
      // };
      // let mask = loading("正在核对您提交的业务数据...");
      // return custInfoModel.getOriginalData(tempCustInfo, that.customerInfo.USER_TYPE).then(res => {
      //   res = _.merge(_.cloneDeep(res), that.historyData);
      //   res.BUSI_COMM_PARAM = that.oppBusiData.busiCommonParams;
      //   let routerIndex = that.$router.getCurrentRouteIndex(),travel = {};
      //   let targetRouter = that.$router.getRoute(routerIndex)||{};
      //   travel[routerIndex] = {
      //     MODULE_NAME: targetRouter.name || "",
      //     REJECT: "0",
      //     MODULES: "modules" in targetRouter ? targetRouter.modules : "",
      //     YGT_MODULE: "ygtModule" in targetRouter ? targetRouter.ygtModule : "",
      //   };
      //   let idx = that.$router.getCurrentRouteIndex();
      //   for(let i = idx + 1; i < that.bizRouteTable.length; i++) {
      //     if(that.bizRouteTable[i].show && !this.bizRouteTable[i].ignoreNext && !that.isAllHideModule(i) && that.bizRouteTable[i].name != "normalBiz") {
      //       let bizRouteTableItem = this.bizRouteTable[i];
      //       travel[i] = {
      //         MODULE_NAME: bizRouteTableItem.name || "",
      //         REJECT: "0",
      //         MODULES: "modules" in bizRouteTableItem?bizRouteTableItem.modules : "",
      //         YGT_MODULE: "ygtModule" in bizRouteTableItem?bizRouteTableItem.ygtModule : "",
      //       };
      //       res.routerIndex = i;
      //     }
      //   }
      //   res.TRAVEL = that.historyData.TRAVEL ? Object.assign({}, that.historyData.TRAVEL, travel) : travel;
      //   let opInfo = that.$storage.getJsonSession(that.$definecfg.USER_INFO);
      //   let params = Object.assign({},
      //     _.pick(Object.assign({}, res), "ID_TYPE", "ID_CODE", "USER_TYPE", "CUST_FNAME"), {
      //       OP_CODE: opInfo.OP_CODE,
      //       CUST_INFO: encodeURIComponent(JSON.stringify(_.extend({}, res))),
      //       CUST_CODE: that.customerInfo.CUST_CODE
      //     });
      //   return that.$syscfg.K_Request("Y1001154", params).then( (data) => {
      //     that.$router.push({ path: "/normalBiz" });
      //   }).finally( () => {
      //     mask.close();
      //   });
      // }).catch( err => {
      //   alert(err);
      //   mask.close();
      // });
    },
    updataOppCustInfo (params){
      let that = this;
      let custTempInfoBusiCode = ["V9996", "V9998", "V9997"];
      return oppService.updateOppBusiCustInfo({
        ID_TYPE: that.customerInfo.ID_TYPE,
        ID_CODE: that.customerInfo.ID_CODE,
        CUST_FNAME: that.customerInfo.CUST_FNAME,
        USER_TYPE: that.customerInfo.USER_TYPE,
        OP_CODE: that.$storage.getJsonSession(that.$definecfg.USER_INFO).OP_CODE,
        CUST_CODE: that.customerInfo.CUST_CODE || ""
      },Object.assign(params,{
        BUSI_CODE: custTempInfoBusiCode[that.userType]
      }));
    },
    clickLeftStepBack (val){
      if(val != ""){
        this.$router.goRoute(val);
      }
    },
    //点击左侧列表
    leftItemClick (index){
      let busiInfo = this.$storage.getJsonSession(this.$definecfg.BUSI_INFO);
      let stepPassObj = this.historyData.TRAVEL||{};
      // let stepPassObj = busiInfo?this.nodeType=="baseInfoNode"&&busiInfo.CUST_INFO&&busiInfo.CUST_INFO.TRAVEL?busiInfo.CUST_INFO.TRAVEL:(busiInfo.TRAVEL||{}): (this.oppBusiData.newBusiData && this.oppBusiData.newBusiData.TRAVEL||{});
      let currentIndex = this.$router.getCurrentRouteIndex();
      let passStepIndex = _.findIndex(this.bizRouteTable,function (item,bindex){
        return (!stepPassObj[bindex]||stepPassObj[bindex].REJECT=="1"||stepPassObj[bindex].REJECT=="2")&&item.showButton!==false&&item.show&&bindex>=currentIndex;
      });
      let pathName = this.leftStepArr[index].name;
      if(this.leftStepArr[index].fromParent){
        let tarRouter = _.find(this.bizRouteTable,item=>{
          return this.leftStepArr[index].fromParent == item.from&&item.show;
        });
        pathName = tarRouter.name;
      }
      let targetIndrx = this.$router.getRouteIndex(pathName);
      if(passStepIndex==-1||passStepIndex>targetIndrx){
        this.isClickLeftStep = pathName;
      }
    },
    //点击顶部列表
    topItemClick (index){
  
      let pathName = this.secondTopStepArr[index].name;
      let targetIndrx =this.$router.getRouteIndex(pathName);
      let busiInfo = this.$storage.getJsonSession(this.$definecfg.BUSI_INFO);
      // let stepPassObj = busiInfo?this.nodeType=="baseInfoNode"&&busiInfo.CUST_INFO&&busiInfo.CUST_INFO.TRAVEL?busiInfo.CUST_INFO.TRAVEL:(busiInfo.TRAVEL||{}): (this.oppBusiData.newBusiData && this.oppBusiData.newBusiData.TRAVEL||{});
      let stepPassObj = this.historyData.TRAVEL||{};
      let passStepIndex = _.findIndex(this.bizRouteTable,function (item,bindex){
        return (!stepPassObj[bindex]||stepPassObj[bindex].REJECT=="1"||stepPassObj[bindex].REJECT=="2")&&item.showButton!==false&&item.show!==false;
      });
      if(passStepIndex==-1||passStepIndex>targetIndrx){
        
        let that = this;
        that.isClickLeftStep = pathName;
   
      }
    },
    //获取左侧导航序号
    getleftStepIndex (){
      let sIndex = 0;
      _.each(this.leftStepArr,(item,index)=>{
        if(this.secondNodeType=="base"){
          if(item.path==this.$router.getCurrentRoute().path){
            sIndex = index;
          }
        }else{
          if(item.fromParent===this.secondNodeType){
            sIndex = index;
          }
        }
      });
      return sIndex;
    },
    showLoading (text) {
      if (!!text) {
        this.myLoading({
          loadingText: text || "正在核对您的业务状态&请稍候...",
          autoHide: false
        });
      } else {
        this.myLoading({
          showLoading: false
        });
      }
    },
  },
  watch: {
    pageNum (val) {
      if(val >= 0) {
        this.initPage();
      }
    },
    pageName (val) {
      if(val) {
        this.initPage();
      }
    },
    module (val) {
      if(val) {
        this.initPage();
      }
    },
    nodeType (val){
      this.secondTopStepArr = [];
      this.getChildernStep(val);
    },
    secondNodeType (val){
      if(val=="base"){
        this.leftStepArr = this.getLeftStepStatus(this.leftStepArr);
        this.nodeType=="baseInfoNode"&&this.$router.goNext();
      }else{
        this.leftStepArr = this.getLeftStepStatus(this.leftStepArr);
        this.getSecondChildernStep(val);
      }
    },
    updateRouteTableFlag (val){
      if(val){
        this.getChildernStep(this.nodeType);
        this.$store.commit(this.$types.UPDATE_ROUTE_TABLE_FLAG, false);
      }
    },
    isShowButton (val) {
      this.showButton = val;
    }
  }
};
</script>

<style lang="less">
.bizFlow-page .bizFlow-page {
  height: 100%;
  padding: 0 !important;
  display: flex;
  overflow-x: hidden;
  // margin-top: 16px;
  .flowLeftPart{
    height: 100%;
    z-index:1;
    box-shadow: 1px 0px 0px 0px rgba(0, 0, 0, 0.08);
  }
  .routeBox{
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    // padding-left:20px;
    // background: #fff;
    // margin-right: 60px;
  }
  .hasSecondTitle {
    padding-top: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bizFlow/bizFlow.vue